module.exports = __webpack_public_path__ + "static/InCountry-103369de237c8682f120932f256c09de.jpg";